import DropDown from "./Others/Dropdown.vue";

// Modals
import Modal from "./Others/Modal.vue";

//Tabs
import Tabs from "./Tabs/Tabs.vue";
import TabsWings from "./Tabs/TabsWings.vue";
import WTabs from "./Tabs/WTabs.vue";
import WTab from "./Tabs/WTab.vue";

import LoginCard from "./Cards/LoginCard.vue";
import ChartCard from "./Cards/ChartCard.vue";

import Collapse from "./Others/Collapse.vue";

import Pagination from "./Others/Pagination.vue";
import SidebarPlugin from "./SidebarPlugin";
import NotificationPlugin from "./NotificationPlugin";
import AccessDenied from "./Others/AccessDenied.vue";
import FieldTooltip from './Others/FieldTooltip.vue';
import ScrollButton from './Others/ScrollButton.vue';

// wings
import NumberWings from './Inputs/NumberWings.vue';
import NewNumberWings from './Inputs/NewNumberWings.vue';
import PriceWings from './Inputs/PriceWings.vue';
import NewPriceWings from './Inputs/NewPriceWings.vue';
import SelectWings from './Inputs/SelectWings.vue';
import ToggleWings from './Inputs/ToggleWings.vue';
import FastDateDetailWings from './Inputs/FastDateDetailWings.vue';
import FastDateGroupWings from './Inputs/FastDateGroupWings.vue';
import TimeoutWings from './DatePicker/TimeoutWings.vue';
import DatePickerWings from './DatePicker/DatePickerWings.vue';
import BaseFilter from "./Filter/BaseFilter";
import FilterWings from './Filter/FilterWings.vue';
import FilterSelectedItemWings from './Filter/FilterSelectedItemWings.vue';
import FormRowWings from './Form/FormRowWings.vue';
import SpoilerWings from './Others/SpoilerWings.vue';
import ErrorsWings from './Others/ErrorsWings.vue';
import TooltipWings from './Others/TooltipWings.vue';
import LongTextWings from './Others/LongTextWings.vue';
import ChartCardWings from './Cards/ChartCardWings.vue';
import ChartCardDashboardWings from './Cards/ChartCardDashboardWings.vue';
import PieChart from './Charts/PieChart.vue';
import LineChart from './Charts/LineChart.vue';
import BarChart from './Charts/BarChart.vue';
import Througoutput from './Inputs/Througoutput.vue';
import TimeoutInputWings from './Inputs/TimeoutInputWings.vue';
import TemplateInputWings from './Inputs/TemplateInputWings.vue';
import SmsTextInputWings from './Inputs/SmsTextInputWings.vue';

export {
  AccessDenied,
  FieldTooltip,
  ScrollButton,
  Modal,
  Pagination,
  LoginCard,
  ChartCard,
  DropDown,
  SidebarPlugin,
  NotificationPlugin,
  Tabs,
  TabsWings,
  WTabs,
  WTab,
  Collapse,
  PriceWings,
  NewPriceWings,
  DatePickerWings,
  NumberWings,
  NewNumberWings,
  SelectWings,
  ToggleWings,
  BaseFilter,
  FilterWings,
  FilterSelectedItemWings,
  FormRowWings,
  SpoilerWings,
  ErrorsWings,
  TooltipWings,
  TimeoutWings,
  LongTextWings,
  FastDateDetailWings,
  FastDateGroupWings,
  PieChart,
  LineChart,
  BarChart,
  ChartCardWings,
  ChartCardDashboardWings,
  Througoutput,
  TimeoutInputWings,
  TemplateInputWings,
  SmsTextInputWings
};
